import React from 'react';

import EntityList from './entity-list';
import { t } from '../locales/i18n';

import ControlBoxCard from './cards/control-box-card';
import QueueCard from './cards/queue-card';
import LocationCard from './cards/location-card';
import BoothCard from './cards/booth-card';
import DisplayCard from './cards/display-card';
import KioskCard from './cards/kiosk-card';
import ServiceCard from './cards/service-card';

import ControlBoxForm from './forms/control-box-form';
import QueueForm from './forms/queue-form';
import LocationForm from './forms/location-form';
import BoothForm from './forms/booth-form';
import DisplayForm from './forms/display-form';
import KioskForm from './forms/kiosk-form';
import ServiceForm from './forms/service-form';

import AddItemDialog from './dialogs/add-item-dialog';
import styled from 'styled-components';
import { colors } from '../themes';
import { Button } from 'semantic-ui-react';
import { FullInfoCard } from './cards/full-info-card';

const Container = styled.div`
  display: grid;
  justify-content: center;

  background-color: ${colors.lightColors.grey};
  min-height: 100vh;
`;
const ActionPanel = styled.section`
  position: fixed;
  right: 10px;
  background-color: ${colors.lightColors.grey};
`;
const List = styled.ul`
  display: grid;
  grid-gap: 20px;
  margin-top: 0px;
  padding-top: 50px;

  grid-template-columns: 500px;

  @media (min-width: 1280px) {
    grid-template-columns: repeat(2, 500px);
  }
  /* Large devices */
  @media (min-width: 1700px) {
    grid-template-columns: repeat(3, 500px);
    grid-gap: 60px;
    row-gap: 20px;
  }
  list-style-type: none;
  > li {
    background-color: ${colors.neutralColors.white};
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function Dashboard(props: any) {
  return (
    <Container>
      <ActionPanel>
        <Button.Group>
          <AddItemDialog title={t('Control Box')} form={ControlBoxForm} />
          <AddItemDialog title={t('Queue')} form={QueueForm} />
          <AddItemDialog title={t('Booth')} form={BoothForm} />
          <AddItemDialog title={t('Display')} form={DisplayForm} />
          <AddItemDialog title={t('Kiosk')} form={KioskForm} />
          <AddItemDialog title={t('Location')} form={LocationForm} />
          <AddItemDialog title={t('Service')} form={ServiceForm} />
        </Button.Group>
      </ActionPanel>
      <List>
        <FullInfoCard />
        <EntityList dispatch={props.dispatch} itemTemplate={ControlBoxCard} items={props.controlBoxes.myControlBoxes} />
        <EntityList dispatch={props.dispatch} itemTemplate={QueueCard} items={props.queues.myQueues} />
        <EntityList dispatch={props.dispatch} itemTemplate={BoothCard} items={props.booths.myBooths} />
        <EntityList dispatch={props.dispatch} itemTemplate={DisplayCard} items={props.displays.myDisplays} />
        <EntityList
          dispatch={props.dispatch}
          itemTemplate={KioskCard}
          items={props.kiosks.myKiosks}
          queues={props.queues.myQueues}
          services={props.services.myServices}
        />
        <EntityList dispatch={props.dispatch} itemTemplate={ServiceCard} items={props.services.myServices} />
        <EntityList dispatch={props.dispatch} itemTemplate={LocationCard} items={props.locations.myLocations} />
      </List>
    </Container>
  );
}
